"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingDropdown = void 0;
var React = require("react");
var dropdown_1 = require("wix-ui-core/dist/src/components/dropdown");
var DropdownOption_1 = require("../Dropdown/DropdownOption");
var TPAComponentsConfig_1 = require("../TPAComponentsConfig");
var FloatingDropdown_st_css_1 = require("./FloatingDropdown.st.css");
var FloatingDropdownBase_1 = require("./FloatingDropdownBase");
var constants_1 = require("./constants");
var dropdown_option_1 = require("wix-ui-core/dist/src/components/dropdown-option");
var helpers_1 = require("../Dropdown/helpers");
/* TODO
 * The import below is a workaround. FloatingDropdown and Dropdown
 * components should be refactored according to this thread
 * https://github.com/wix/wix-ui-tpa/pull/387 (or merged into a single component)
 */
var Dropdown_st_css_1 = require("../Dropdown/Dropdown.st.css");
var classnames_1 = require("classnames");
/** Dropdown component for sort. */
var FloatingDropdown = /** @class */ (function (_super) {
    __extends(FloatingDropdown, _super);
    function FloatingDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isExpanded: false,
        };
        _this._onSelect = function (selectedOption) {
            if (!selectedOption) {
                return;
            }
            if (_this.props.onChange) {
                _this.props.onChange(selectedOption);
            }
        };
        _this._onCoreSelect = function (selectedCoreOption) {
            if (!selectedCoreOption) {
                return;
            }
            var selectedOption = _this.props.options.find(function (_a) {
                var id = _a.id;
                return selectedCoreOption.id === id;
            });
            _this._onSelect(selectedOption);
        };
        _this._onExpandedChange = function (isExpanded) {
            var onExpandedChange = _this.props.onExpandedChange;
            _this.setState({ isExpanded: !_this.state.isExpanded }, function () { return onExpandedChange && onExpandedChange(isExpanded); });
        };
        return _this;
    }
    FloatingDropdown.prototype._generateCoreOptions = function () {
        var options = this.props.options;
        var coreOptions = options.map(function (option) {
            return option.divider
                ? dropdown_option_1.OptionFactory.createDivider({ className: FloatingDropdown_st_css_1.classes.optionDivider })
                : dropdown_option_1.OptionFactory.create(__assign(__assign({}, option), { 
                    // Should internally add the `isSelectable` property to the item (needed by the wix-ui-core dropdown in order to trigger the onClick event)
                    isSelectable: option.unavailable && option.isSelectable === undefined
                        ? true
                        : option.isSelectable, render: function () { return (React.createElement(DropdownOption_1.DropdownOption, __assign({ className: FloatingDropdown_st_css_1.classes.option }, option))); } }));
        });
        return {
            coreOptions: coreOptions,
        };
    };
    FloatingDropdown.prototype._getContent = function (mobile) {
        var _a = this.props, ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"], disabled = _a.disabled, forceContentElementVisibility = _a.forceContentElementVisibility, label = _a.label, placeholder = _a.placeholder, value = _a.value, options = _a.options, name = _a.name, id = _a.id, placement = _a.placement, appendTo = _a.appendTo, displayBlock = _a.displayBlock;
        var coreOptions = this._generateCoreOptions().coreOptions;
        var baseElement = (React.createElement(FloatingDropdownBase_1.FloatingDropdownBase, { className: FloatingDropdown_st_css_1.classes.floatingDropdownBase, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, disabled: disabled, label: label, placeholder: placeholder, value: value, name: name, mobile: mobile, options: helpers_1.modifyOptions(options), id: id, isExpanded: this.state.isExpanded, onChange: this._onSelect, displayBlock: displayBlock }));
        return mobile ? (baseElement) : (React.createElement(dropdown_1.Dropdown, { className: FloatingDropdown_st_css_1.classes.dropdown, contentClassName: Dropdown_st_css_1.classes.dropdownContainer, "data-hook": constants_1.DATA_HOOKS.coreDropdown, "data-mobile": mobile, forceContentElementVisibility: forceContentElementVisibility, initialSelectedIds: value ? [value] : [], onInitialSelectedOptionsSet: function () { }, onDeselect: this._onCoreSelect, onSelect: this._onCoreSelect, openTrigger: 'click', disabled: disabled, options: coreOptions, placement: placement, onExpandedChange: this._onExpandedChange, appendTo: appendTo, dynamicWidth: appendTo === 'window' ? true : undefined, dropdownA11yFixes: true }, baseElement));
    };
    FloatingDropdown.prototype.render = function () {
        var _this = this;
        return (React.createElement(TPAComponentsConfig_1.TPAComponentsConsumer, null, function (_a) {
            var _b;
            var mobile = _a.mobile;
            return (React.createElement("div", { "data-mobile": mobile, "data-hook": _this.props['data-hook'], className: FloatingDropdown_st_css_1.st(FloatingDropdown_st_css_1.classes.root, { mobile: mobile }, classnames_1.default(FloatingDropdown_st_css_1.classes.overrideStyleParams, _this.props.className, (_b = {},
                    _b[FloatingDropdown_st_css_1.classes.displayInline] = !_this.props.displayBlock,
                    _b))) }, _this._getContent(mobile)));
        }));
    };
    FloatingDropdown.displayName = 'FloatingDropdown';
    FloatingDropdown.defaultProps = {
        disabled: false,
        options: [],
        placement: 'bottom',
        displayBlock: false,
    };
    return FloatingDropdown;
}(React.Component));
exports.FloatingDropdown = FloatingDropdown;
//# sourceMappingURL=FloatingDropdown.js.map